/**
 * @generated SignedSource<<98f916967661b5d0d7071fdaea47b3f3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UpdateNavSectionButtonFragment$data = {
  readonly id: string;
  readonly title: string;
  readonly " $fragmentType": "UpdateNavSectionButtonFragment";
};
export type UpdateNavSectionButtonFragment$key = {
  readonly " $data"?: UpdateNavSectionButtonFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"UpdateNavSectionButtonFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UpdateNavSectionButtonFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    }
  ],
  "type": "NavSection",
  "abstractKey": null
};

(node as any).hash = "cfa8bde143fc503a577bcabccfbe00c9";

export default node;
